import { Injectable }       from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { UserVideo } from 'src/app/models/user-video';
import { Playlist } from 'src/app/models/playlist';
import { Report } from 'src/app/models/report';

import { BaseService } from './base.service';

// import 'rxjs/add/operator/toPromise';

@Injectable()
export class FormService extends BaseService {
  
  constructor(
    // private auth: Auth,
    private http: HttpClient,
) {
    super();
  }

  async postLeadForm(params): Promise<any> {

    console.log(params);

    let body = JSON.stringify(params);

    let headers:any = new HttpHeaders().set('Content-Type', 'application/json');
    let url = "/postLeadForm";
    return this.http.post(this.getCloudApiUrl(url), body, {headers: headers})
               .toPromise()
               .then((response: any) => {
                 console.log(response);
                 
                 if(! response){
                   return this.handleError;
                 }
                 return response;
               })
               .catch(this.handleError);
  }

}

